// ContactRequestsPage.jsx
import React, { useState, useEffect, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { getContactRequests, updateContactRequest } from '../../utils/api';

export const ContactRequestsPage = () => {
    const [rowData, setRowData] = useState([]);
    const gridRef = useRef();

    useEffect(() => {
        fetchContactRequests();
    }, []);

    const fetchContactRequests = async () => {
        try {
            const res = await getContactRequests();
            setRowData(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const columnDefs = [
        { field: 'id', headerName: 'ID', filter: true, sortable: true },
        { field: 'mobile', headerName: 'Mobile', filter: true, sortable: true },
        { field: 'email', headerName: 'Email', filter: true, sortable: true, flex: 2 },
        {
            field: 'done',
            headerName: 'Done',
            cellRenderer: (params) => (
                <input type="checkbox" checked={params.value} readOnly className="mr-2" />
            ),
            filter: 'agSetColumnFilter',
            width: 100
        },
        {
            headerName: 'Actions',
            cellRenderer: (params) => (
                <button
                    onClick={() => handleToggle(params.data.id, params.data.done)}
                    className={`px-2 py-1 rounded text-sm ${params.data.done ? 'bg-gray-500' : 'bg-yellow-500'} text-white`}
                >
                    {params.data.done ? 'Mark Undone' : 'Mark Done'}
                </button>
            ),
            width: 150
        }
    ];

    const defaultColDef = {
        resizable: true,
        sortable: true,
        filter: true
    };

    const onGridReady = (params) => {
        gridRef.current.api = params.api;
    };

    const handleToggle = async (id, currentDone) => {
        try {
            await updateContactRequest(id, { done: !currentDone });
            fetchContactRequests();
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <div className="bg-white p-6 rounded shadow">
            <h1 className="text-2xl font-bold mb-6">Contact Requests</h1>
            <div className="ag-theme-alpine" style={{ height: 500, width: '100%' }}>
                <AgGridReact
                    ref={gridRef}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    onGridReady={onGridReady}
                    animateRows={true}
                />
            </div>
        </div>
    );
};